const YouTube = ({ width = '24px', height = '24px' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
      <path
        d="M19.376 7.03C18.8 6.298 17.732 6 15.696 6H8.304C6.22 6 5.136 6.318 4.56 7.097 4 7.857 4 8.975 4 10.524v2.952c0 3 .666 4.524 4.304 4.524h7.392c1.766 0 2.745-.263 3.378-.91.649-.661.926-1.742.926-3.614v-2.952c0-1.633-.043-2.759-.624-3.494zm-5.104 5.378l-3.357 1.87a.49.49 0 01-.506-.018.559.559 0 01-.249-.47v-3.728c0-.192.094-.37.248-.47a.489.489 0 01.506-.018l3.357 1.858c.17.094.278.282.278.487a.556.556 0 01-.277.489z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default YouTube;
